<!-- 
create by melody on 2018/11/1 
description:菜单管理页面 
-->
<template>
    <div>
       <page-header :title="title"></page-header>
       <div class="search-container">
            <el-form label-width="100px">
                <el-row>
                    <el-col :xl="8" :lg="10" :md="12">
                        <el-form-item :label="$t('m.keyName')" style="width: 400px;">
                            <el-input v-model="searchParam.keyName" :placeholder="$t('m.menuNameOrCode')" clearable></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item style="width: 400px;">
                    <lap-search-btn :searchParam="searchParam" @successMethod="getDemoList()"></lap-search-btn>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-container">
            <el-button type="primary" plain icon="el-icon-plus" @click="handleClick('add')"> {{$t('m.add')}} </el-button>
            <el-table
                ref="multipleTable"
                :data="tableData"
                stripe
                tooltip-effect="dark"
                style="width: 100%;margin: 24px 0"
                >
                <el-table-column
                    type="index">
                </el-table-column>
                <el-table-column
                    :label="$t('m.menuName')"
                    prop="menuName"
                    width="170">
                </el-table-column>
                <el-table-column
                    prop="menuCode"
                    :label="$t('m.menuCode')"
                    width="200">
                </el-table-column>
                <el-table-column
                    prop="menuLink"
                    :label="$t('m.menuLink')"
                    width="190">
                </el-table-column>
                <el-table-column
                    prop="menuType"
                    :label="$t('m.menuType')"
                    width="130">
                </el-table-column>
                <el-table-column
                    prop="menuParentCode"
                    :label="$t('m.menuParentCode')"
                    width="150">
                </el-table-column>
                <el-table-column
                    prop="menuParentName"
                    :label="$t('m.menuParentName')"
                    width="150">
                </el-table-column>
                <el-table-column
                    prop="menuSortNum"
                    :label="$t('m.menuSortNum')">
                </el-table-column>
                <el-table-column
                    prop="menuIcon"
                    :label="$t('m.menuIcon')">
                </el-table-column>
                <el-table-column
                    prop="enableFlag"
                    :label="$t('m.enableFlag')"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.enableFlag == true ? $t('m.enable') : $t('m.disable')}}</span>
                    </template>
                </el-table-column>
                <el-table-column 
                    fixed="right"
                    width="150" 
                    :label="$t('m.operation')">
                    <template slot-scope="scope">
                        <el-button
                            icon="el-icon-edit-outline" 
                            plain
                            size="mini"
                            @click="handleClick('modify', scope.row)"></el-button>
                        <el-button
                            icon="el-icon-delete"
                            plain
                            size="mini"
                            type="danger"
                            @click="handleDelete('single',scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <lap-pagination :total="total" :searchParam="searchParam" @successMethod="getDemoList()"></lap-pagination>
        </div>
        <el-dialog
            :title="operateType=='add'? $t('m.add') :operateType=='modify'? $t('m.modify') :''"
            v-if="dialogVisible"
            :visible.sync="dialogVisible"
            width="30%">
            <div class="dialog-content">
                <el-form ref="form" :model="form" :rules="rules" label-width="140px">
                    <el-form-item :label="$t('m.menuName')" prop="menuName" style="width: 100%">
                        <el-input v-model.trim="form.menuName" :maxlength="$inputLengthObj.maxLength4"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.menuCode')" prop="menuCode" style="width: 100%">
                        <el-input v-model.trim="form.menuCode" :maxlength="$inputLengthObj.maxLength4"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.menuLink')" prop="menuLink" style="width: 100%">
                        <el-input v-model.trim="form.menuLink" :maxlength="$inputLengthObj.maxLength4"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.menuType')" prop="menuType" style="width: 100%">
                        <el-select v-model="form.menuType">
                            <el-option :label="$t('m.firstMenu')" value="FIRST_MENU"></el-option>
                            <el-option :label="$t('m.secondMenu')" value="SECOND_MENU"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('m.menuParentCode')" v-if="form.menuType == 'SECOND_MENU'" prop="menuParentCode" style="width: 100%">
                        <el-select v-model="form.menuParentCode" @change="selectChange">
                            <el-option v-for="(item, index) in firstMenuList" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('m.menuSortNum')" prop="menuSortNum" style="width: 100%">
                        <el-input v-model.trim="form.menuSortNum" :maxlength="$inputLengthObj.maxLength6"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.menuIcon')" prop="menuIcon" style="width: 100%">
                        <el-input v-model.trim="form.menuIcon" :maxlength="$inputLengthObj.maxLength4"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('m.enableFlag')" prop="enableFlag" style="width: 100%">
                        <el-radio-group  v-model="form.enableFlag">
                            <el-radio :label="true" checked>{{$t('m.enable')}}</el-radio>
                            <el-radio :label="false">{{$t('m.disable')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <span v-if="operateType!='view'" slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{$t('m.cancel')}}</el-button>
                <el-button type="primary" :disabled="addDisable" @click="haddleSave(operateType)">{{$t('m.sure')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            title:{
                firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.SYSTEM_MANAGE'),
                thirdTitle: this.$t('m.MENU_MANAGE')
            },
            searchParam: {      //查询参数
                keyName: '',
                pageSize: 10,
                pageNum: 1,
            },
            form: {     //弹框内容
                menuId: '',
                menuName: '',
                menuCode: '',
                menuType: '',
                enableFlag: true,
                menuLink: '',
                menuParentCode: '',
                menuParentName: '',
                menuSortNum: '',
                menuIcon: ''
            },
            rules: this.$ruleApi.getRule('menu'),
            tableData: [],  //表数据
            total: 0,   //总数
            dialogVisible: false,   //控制弹框显示与隐藏
            operateType: '',    //操作类型 add新增 modify修改 view查看
            firstMenuList:[],
            addDisable: false
        }
    },
    methods: {
        selectChange(val) {
            let obj = {};
            obj = this.firstMenuList.find((item)=>{
                return item.value === val;
            });
            this.form.menuParentName = obj.label
        },
        getDemoList() {
            this.$commonFunc.commonRequest('get', '/system/menuManage/list/condition', 'getMenuList', this.searchParam)
            .then(res=>{
                this.tableData = res.obj.list
                this.total = res.obj.total
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        viewDemo(row) {
            this.viewDialogVisible = true
            this.$commonFunc.commonRequest('get', '/system/menuManage/query', 'viewMenu', {menuId: row.menuId})
            .then(res=>{
                this.form = res.obj
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        addDemo() {
            this.$commonFunc.commonRequest('post', '/system/menuManage/added', 'addMenu', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.addSuccess'));
                this.addDisable = false
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
                this.addDisable = false
            })
        },
        modifyDemo() {
            this.$commonFunc.commonRequest('post', '/system/menuManage/modified', 'modifyMenu', this.form)
            .then(res=>{
                this.$message.success(this.$t('m.modifySuccess'));
                this.dialogVisible = false
                this.getDemoList()
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        //处理新增、修改、查看点击
        handleClick(type,row) {
            this.operateType = type
            this.dialogVisible = true
            //如果操作已有数据
            if(row) {
                this.viewDemo(row)
            } else {
                this.form = {
                    menuId: '',
                    menuName: '',
                    menuCode: '',
                    menuType: '',
                    enableFlag: true,
                    menuLink: '',
                    menuParentCode: '',
                    menuParentName: '',
                    menuSortNum: '',
                    menuIcon: ''
                }
            }
        },
        //弹框保存操作
        haddleSave(type) {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    if(type=='add') {
                        this.addDisable = true
                        this.addDemo()
                    } else {
                        this.modifyDemo()
                    }
                } else {
                    return false;
                }
            });
        },
        handleDelete(type,row) {
            this.$confirm(this.$t('m.sureDelete'), this.$t('m.tips'), {
                confirmButtonText: this.$t('m.sure'),
                cancelButtonText: this.$t('m.cancel'),
                type: 'warning'
            })
            .then(() => {
                //单个删除
                if(type == 'single') {
                    this.$commonFunc.commonRequest('get', '/system/menuManage/deleted', 'deleteMenu', {menuId: row.menuId})
                    .then(res=>{
                        this.$message.success(this.$t('m.deleteSuccess'));
                        this.getDemoList()
                    })
                //批量删除
                } 
            })
        },
        //之后用store
        getMenus() {
            this.$commonFunc.commonRequest('get', '/system/menuManage/list')
            .then(res=>{
                if(res.obj.length) {
                    let arr = []
                    res.obj.forEach(function(o,i) {
                        arr.push({value: o.menuCode, label: o.menuName})
                    })
                    this.firstMenuList = arr
                }
                
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
    },
    mounted() {
        this.getDemoList()
        this.getMenus()
    }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/sys/MenuManage.vue